<template>
  <div class="main-pages">
    <div class="container-fluid p-4">
      <div class="vld-parent">
        <loading :active.sync="isLoading" :is-full-page="true"></loading>
      </div>
      <span class="pageSteps card-styling" style="margin-top: 125px">
        <p style="font-weight: 300; font-style: normal">Dashboard</p>

        <img
          style="margin: 0 17px"
          :src="require(`@/assets/images/svg/ícone-seta-direita-cinza.svg`)"
          alt=""
        />

        <p style="font-style: normal; font-weight: 500">Usuários</p>
      </span>
      <div class="cardSteps mt-5">
        <StepProgress
          :mySteps="mystep"
          :currentStep="currentStep"
          @checkCurrentStep="checkCurrentStep"
        />
        <FacebookLogin ref="modalFacebook" @showIsLoading="showIsLoading" />
        <form @submit.prevent="">
          <div class="col-12">
            <div class="row">
              <div class="col-lg-6 col-sm-12">
                <span class="titleForm">{{
                  step === 0
                    ? "Dados Pessoais"
                    : step === 1
                    ? "Lojas Associadas"
                    : ""
                }}</span>
              </div>
              <div class="col-lg-2" v-if="step === 1">
                <InputSearch @onUpdate="(value) => getStoreByName(value)" />
              </div>
              <div class="col-lg-2" v-if="step === 1">
                <button
                  class="w-100 btnPrimaryWhite"
                  @click.prevent="toggleSelectAll"
                >
                  {{ allStoresSelected ? 'Remover Todos' : 'Selecionar Todos' }}
                </button>
              </div>
              <div class="col-lg-2" v-if="step === 1">
                <button
                  class="w-100 btnPrimaryWhite"
                  @click.prevent="showModalFacebook"
                >
                  Novo Instagram
                </button>
              </div>
            </div>

            <div class="row">
              <div class="col-lg-6 col-sm-12 mt-3">
                <Input
                  v-if="step === 0 || step === 2"
                  :inputValue="user.name"
                  inputId="nome"
                  :inputType="'text'"
                  :inputLabel="'Nome'"
                  :inputTypeNotValidation="true"
                  @isValid="isValid()"
                  @onUpdate="(value) => handleInputValue('name', value)"
                  :disabled="step === 2 ? true : false"
                />
              </div>
              <div class="col-lg-6 col-sm-12 mt-3">
                <Input
                  v-if="step === 0 || step === 2"
                  :inputValue="user.email"
                  inputId="email"
                  :inputType="'email'"
                  :inputLabel="'E-mail'"
                  :required="true"
                  :isValid="isOkEmail"
                  @isValid="isValid()"
                  @onUpdate="(value) => handleInputValue('email', value)"
                  :disabled="step === 2 ? true : false"
                />
              </div>
              <div class="col-lg-6 col-sm-12 mt-3">
                <Input
                  v-if="step === 0"
                  :inputValue="user.password"
                  inputId="password"
                  :inputType="typePassword === true ? 'password' : 'text'"
                  :inputLabel="'Senha'"
                  :required="true"
                  :isValid="isOkPassword"
                  @isValid="isValid()"
                  @onUpdate="(value) => handleInputValue('password', value)"
                  @clickVerSenha="typePassword = !typePassword"
                />
                <span v-if="!isOkPassword && user.password > 0">
                  <p
                    style="
                      font-style: normal;
                      font-weight: 400;
                      font-size: 13px;
                      margin: 5px 0;
                      color: var(--red-medium);
                    "
                  >
                    {{ statusPassword }}
                  </p>
                </span>
              </div>
              <div class="col-lg-6 col-sm-12 mt-3">
                <Input
                  v-if="step === 0"
                  :isValid="isOkConfpassword"
                  :inputValue="user.confPassword"
                  inputId="confPassword"
                  :inputType="typePasswordConf === true ? 'password' : 'text'"
                  :inputLabel="'Confirmar Senha'"
                  @isValid="isValid()"
                  @onUpdate="(value) => handleInputValue('confPassword', value)"
                  @clickVerSenha="typePasswordConf = !typePasswordConf"
                />
                <span v-if="!isOkConfpassword && user.password > 0">
                  <p
                    style="
                      font-style: normal;
                      font-weight: 400;
                      font-size: 13px;
                      margin: 5px 0;
                      color: var(--red-medium);
                    "
                  >
                    As senhas não conferem
                  </p>
                </span>
              </div>
              <div class="col-12 mt-3" v-if="step === 0">
                <span class="titleCriarSenha">Crie sua senha</span>
                <ul>
                  <li>Mínimo 8 caracteres</li>
                  <li>Letras maiúsculas e minúsculas</li>
                  <li>Número e símbolo</li>
                </ul>
              </div>
            </div>

            <div class="row" v-show="step === 1">
              <div class="col-lg-4" v-for="store in stores" :key="store.id">
                <Store
                  :nameStore="store.name"
                  :newUsuario="true"
                  @isSelected="isSelected"
                  @clickStore="addRole"
                  :idStore="store.id"
                  :hideCheckBox="step === 2 ? true : false"
                  :isChecked="storeIsChecked(store.name)"
                />
              </div>
            </div>
            <div class="row" v-show="step === 2">
              <div
                class="col-lg-4"
                v-for="store in perfilAssociadoWithId"
                :key="store.id"
              >
                <Store
                  :nameStore="store.name"
                  :newUsuario="true"
                  @isSelected="isSelected"
                  @clickStore="addRole"
                  :idStore="store.id"
                  :hideCheckBox="step === 2 ? true : false"
                  :changeTextButton="true"
                />
              </div>
            </div>
            <div class="row" v-if="step === 1">
              <Pagination
                :count="totalStores"
                :offset="offset"
                @firstPage="pagination('clickFirstPage')"
                @previousPage="pagination('clickPreviousPage')"
                @nextPage="pagination('clickNextPage')"
                @lastPage="pagination('clickLastPage')"
                :limit="3"
              />
            </div>
            <div class="row" v-if="step === 3">
              <!-- <StepProgressSuccess :currentStep="2" /> -->
              <span class="titleForm">Dados Pessoais</span>
              <div class="col-lg-6 col-sm-12">
                <Input
                  :inputValue="user.name"
                  inputId="nome"
                  :inputType="'text'"
                  :inputLabel="'Nome'"
                  :disabled="true"
                />
              </div>
              <div class="col-lg-6 col-sm-12 mt-3">
                <Input
                  :inputValue="user.email"
                  inputId="email"
                  :inputType="'email'"
                  :inputLabel="'E-mail'"
                  :disabled="true"
                />
              </div>
              <div class="row mt-5">
                <span class="titleForm">Lojas associadas</span>
                <div
                  class="col-lg-4"
                  v-for="store in perfilAssociado"
                  :key="store.id"
                >
                  <Store
                    :nameStore="store"
                    :newUsuario="false"
                    @isSelected="isSelected"
                    @clickStore="addRole"
                    :idStore="store.id"
                    :revisao="true"
                    :hideCheckBox="true"
                  />
                </div>
              </div>
            </div>
            <div class="row mt-5">
              <div class="d-flex justify-content-end">
                <button
                  class="btn btnSecondary"
                  v-on.prevent="
                    step === 3 || step === 0
                      ? { click: backUser }
                      : { click: backStep }
                  "
                >
                  {{
                    step === 3 ? "Fechar " : step === 0 ? "Voltar" : "Anterior"
                  }}
                </button>
                <button
                  v-if="step < 3"
                  v-on.prevent="
                    step === 2 ? { click: saveUser } : { click: nextStep }
                  "
                  :disabled="isDisabled"
                  class="btn btnPrimary"
                  :class="isDisabled ? 'able' : 'not-enabled'"
                >
                  {{ step === 2 ? "Salvar" : "Próximo" }}
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import StepProgress from "../components/StepProgress.vue";
import Input from "../components/Input.vue";
import InputSearch from "@/components/InputSearch.vue";
import { mapActions, mapMutations, mapGetters } from "vuex";
import Store from "@/components/Store.vue";
import Pagination from "@/components/Pagination.vue";
import Loading from "vue-loading-overlay";
import FacebookLogin from "../components/FacebookLogin.vue";
import formatting from "../plugins/formatting";

export default {
  components: {
    StepProgress,
    Input,
    InputSearch,
    Store,
    Pagination,
    Loading,
    FacebookLogin,
  },
  name: "NewUser",
  data() {
    return {
      mystep: ["Dados Pessoais", "Lojas", "Revisão"],
      user: {
        name: "",
        image: "",
        email: "",
        password: null,
        confPassword: null,
      },
      perfilAssociado: [],
      perfilAssociadoWithId: [],
      currentStep: 0,
      isOkEmail: false,
      isOkNome: false,
      isOkConfpassword: true,
      isOkPassword: false,
      isDisabled: true,
      step: 0,
      stores: [],
      nameToSearch: "",
      totalStores: 0,
      offset: 0,
      isLoading: false,
      checkedPerfil: false,
      idselected: [],
      selectdPerfil: false,
      concluded: false,
      statusPassword: "",
      typePassword: true,
      typePasswordConf: true,
      allStoresSelected: false,
      allStoresData: [],
    };
  },

  created() {
    this.isLoading = true;
    this.getRolesByPagination({
      action: "clickFirstPage",
      offset: 0,
      name: this.nameToSearch,
      limit: 3,
    }).then((response) => {
      this.stores = response.data.data;
      this.totalStores = response.data.count;
      this.isLoading = false;
    });
  },
  computed: {
    ...mapGetters(["getOffset"]),
  },

  methods: {
    ...mapActions(["getRolesByPagination", "adduserRole", "registerUser"]),
    ...mapMutations(["SET_OFFSET"]),

    isSelected(value, el) {
      this.selectdPerfil = !this.selectdPerfil;
      if (this.idselected.includes(el)) {
        this.idselected.findIndex((element, index) => {
          if (element === el) {
            this.idselected.splice(index, 1);
            el.classList.remove("selected");
          }
        });
      } else {
        this.idselected.push(el);
      }

      this.idselected.forEach((e) => {
        e.classList.add("selected");
      });
    },

    addStyleAssociar(el) {
      let classElement = el.classList.contains("selected");
      this.selectdPerfil === true && !classElement
        ? (el.children[0].lastElementChild.children[0].innerHTML =
            "Desassociar")
        : (el.children[0].lastElementChild.children[0].innerHTML = "Associar");
    },

    addRole(value, id, userName, el) {
      this.selectdPerfil = !this.selectdPerfil;
      this.addStyleAssociar(el);

      this.checkedPerfil = value;
      if (!this.perfilAssociado.includes(userName) && value === true) {
        this.perfilAssociado.push(userName);

        this.perfilAssociadoWithId.push({ id: id, name: userName });
      }

      if (value === false) {
        this.perfilAssociado.splice(
          this.perfilAssociado.findIndex((element) => element === userName),
          1
        );

        this.perfilAssociadoWithId.splice(
          this.perfilAssociadoWithId.findIndex(
            (element) => element.name === userName
          ),
          1
        );

        // Se o usuário desselecionar uma loja manualmente, atualiza o estado de "todos selecionados"
        if (this.allStoresSelected && this.perfilAssociado.length < this.totalStores) {
          this.allStoresSelected = false;
        }
      }

      // Verifica se todas as lojas foram selecionadas manualmente
      if (this.perfilAssociado.length === this.totalStores) {
        this.allStoresSelected = true;
      }
    },

    saveUser() {
      this.isLoading = true;
      const arr = formatting.formatListInQueryStringFormat(
        this.perfilAssociado,
        "roles"
      );
      this.registerUser(this.user)
        .then(() => {
          if (this.perfilAssociado.length > 0) {
            this.adduserRole({
              email: this.user.email,
              roles: arr,
            })
              .then(() => {
                alert("Dados salvos com sucesso!");
                this.step = 3;
              })
              .catch((error) => {
                console.log(error);
              });
          }
          this.$router.push({ name: "Users" });
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    handleInputValue(propertyName, propertyValue) {
      this.user = Object.assign(
        {},
        this.user,
        this.setObjectProperty(this.user, propertyName, propertyValue)
      );
    },

    showModalFacebook() {
      this.$refs["modalFacebook"].$refs["modal-Facebook"].show();
    },

    nextStep() {
      this.isDisabled = true;
      if (this.step === 0 || this.step === 1) {
        this.isDisabled = false;
      } else {
        this.isDisabled = true;
      }

      if (this.currentStep < this.mystep.length - 1) {
        this.currentStep++;
      }
    },

    backStep() {
      if (this.currentStep > 0) {
        this.currentStep--;
        this.isDisabled = false;
      }
    },

    backUser() {
      this.$router.push("Users");
    },

    isValid() {
      let isValidEmail = document.getElementById("email").validity.valid;
      let isValidNome = document.getElementById("nome").value;
      let isValidPassword = document.getElementById("password").value;
      let isValidConfirmPassword =
        document.getElementById("confPassword").value;

      this.isOkEmail = isValidEmail;
      this.isOkNome = isValidNome;

      let ucase = new RegExp("[A-Z]+");
      let lcase = new RegExp("[a-z]+");
      let num = new RegExp("[0-9]+");
      let specialcharacter = new RegExp(/\W|_/);

      // condição que verifica se a senha contém os requisitos para nova senha
      if (isValidPassword != " ") {
        if (
          !(isValidPassword.length > 0 && isValidPassword.length >= 8) ||
          !ucase.test(isValidPassword) ||
          !lcase.test(isValidPassword) ||
          !num.test(isValidPassword) ||
          !specialcharacter.test(isValidPassword)
        ) {
          this.statusPassword = "Senha não atende aos requisitos de segurança";
          this.isOkPassword = false;
        } else {
          this.statusPassword = "";
          this.isOkPassword = true;
        }
      } else {
        this.statusPassword = "";
        this.isOkPassword = true;
      }

      //condição que verifica a nova senha se condiz com a confirmação da nova senha
      if (!(isValidConfirmPassword === this.user.password)) {
        this.isOkConfpassword = false;
        this.isPasswordMatch = false;
        this.isDisabled = true;
      } else {
        this.isOkConfpassword = true;
        this.isPasswordMatch = true;
        this.isDisabled = false;
      }

      //Desativa o disabled do button type submit(ao estado default)
      if (isValidPassword == "" || isValidConfirmPassword == "") {
        this.isDisabled = true;
      }
      if (
        this.isOkEmail &&
        isValidNome.length > 4 &&
        this.isOkPassword &&
        this.isOkConfpassword
      ) {
        this.isDisabled = false;
      } else {
        this.isDisabled = true;
      }
    },

    checkCurrentStep(val) {
      this.step = val;
    },

    getStoreByName: function getStoreByName(name) {
      this.nameToSearch = name;

      if (this.nameToSearch != "") {
        let objThis = this;

        clearTimeout(getStoreByName);

        setTimeout(function () {
          objThis.pagination("clickFirstPage");
        }, 500);
      } else {
        this.pagination("clickFirstPage");
      }
    },

    pagination(action) {
      const data = {
        action: action,
        offset: 0,
        name: this.nameToSearch,
        limit: 3,
      };
      switch (action) {
        case "clickFirstPage":
          this.offset = 0;
          this.SET_OFFSET(0);
          this.getRolesByPagination(data).then((response) => {
            this.totalStores = response.data.count;
            this.stores = response.data.data;
          });
          break;
        case "clickPreviousPage": {
          this.SET_OFFSET(this.getOffset - data.limit);
          data.offset = this.getOffset;
          this.offset = this.getOffset;

          this.getRolesByPagination(data).then((response) => {
            this.stores = response.data.data;
          });
          break;
        }
        case "clickNextPage": {
          this.SET_OFFSET(this.getOffset + data.limit);
          data.offset = this.getOffset;
          this.offset = this.getOffset;

          this.getRolesByPagination(data).then((response) => {
            this.stores = response.data.data;
          });
          break;
        }
        case "clickLastPage": {
          let lastPage;
          if (this.totalStores % data.limit === 0) {
            lastPage = this.totalStores - data.limit;
          } else {
            lastPage = Math.floor(this.totalStores / data.limit) * data.limit;
          }

          this.SET_OFFSET(lastPage);

          data.offset = this.getOffset;
          this.offset = this.getOffset;

          this.getRolesByPagination(data).then((response) => {
            this.stores = response.data.data;
          });
          break;
        }
        default:
          break;
      }
    },

    storeIsChecked(name) {
      if (this.perfilAssociado.includes(name)) {
        return true;
      } else {
        return false;
      }
    },

    showIsLoading(newValue) {
      this.isLoading = newValue;
    },

    async selectAllStores() {
      this.isLoading = true;
      try {
        // Busca todas as lojas de uma vez
        const response = await this.getRolesByPagination({
          action: "clickFirstPage",
          offset: 0,
          name: this.nameToSearch,
          limit: this.totalStores, // Busca todas as lojas
        });

        this.allStoresData = response.data.data;

        // Adiciona todas as lojas ao perfilAssociado
        this.perfilAssociado = [];
        this.perfilAssociadoWithId = [];

        this.allStoresData.forEach((store) => {
          if (!this.perfilAssociado.includes(store.name)) {
            this.perfilAssociado.push(store.name);
            this.perfilAssociadoWithId.push({ id: store.id, name: store.name });
          }
        });

        this.allStoresSelected = true;
      } catch (error) {
        console.error("Erro ao selecionar todas as lojas:", error);
      } finally {
        this.isLoading = false;
      }
    },

    deselectAllStores() {
      this.perfilAssociado = [];
      this.perfilAssociadoWithId = [];
      this.allStoresSelected = false;
      this.idselected = [];

      // Remove a classe 'selected' de todos os elementos selecionados
      document.querySelectorAll('.selected').forEach(el => {
        el.classList.remove('selected');
        if (el.children[0] && el.children[0].lastElementChild && el.children[0].lastElementChild.children[0]) {
          el.children[0].lastElementChild.children[0].innerHTML = "Associar";
        }
      });
    },

    toggleSelectAll() {
      if (this.allStoresSelected) {
        this.deselectAllStores();
      } else {
        this.selectAllStores();
      }
    },
  },
  watch: {
    user(val) {
      if (val.name === null || val.name === "") {
        this.isDisabled = true;
      }
      if (val.confPassword === null || val.confPassword === "") {
        this.isDisabled = true;
      }
      if (val.email === null || val.email === "") {
        this.isDisabled = true;
      }
      if (val.password === null || val.password === "") {
        this.isDisabled = true;
      }
    },
  },
};
</script>

<style scoped>
.cardSteps {
  padding: 24px;
  border-radius: 12px;
  box-shadow: 0px 0px 20px -14px #e7dede;
  background: #fefefe;
}

.titleForm {
  color: #959595;
  margin-bottom: 28px;
}

.able {
  background-color: var(--grey-border);
}

.not-enabled {
  background-color: var(--blue-medium);
}

.notSelected {
  border: 1px solid var(--grey-border);
}

.notSelected,
.selected {
  padding: 12px;
  margin: 5px;
  border-radius: 8px;
}

.selected {
  border: 1px solid var(--blue-medium);
  box-shadow: 0px 24px 38px rgba(0, 0, 0, 0.07);
}

ol,
ul,
dl {
  margin-top: 0;
  margin-bottom: 1rem;
  color: var(--grey-medium);
  font-size: 14px;
}

.titleCriarSenha {
  font-size: 15px;
  color: var(--grey-medium);
}
</style>
